/*********************************************************************************************
 * Splide Products reco
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    waitForSplideSections();
});

function waitForSplideSections() {
    const routineSections = document.querySelectorAll('[data-section-product-reco-id]');

    if (routineSections.length > 0) {
        routineSections.forEach(function (section) {
            const id = '.mm-product-reco-splide';
            const splideElem = section.querySelector(id);

            if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
                mmSplideInit(splideElem, section);
            } else {
                setTimeout(waitForSplideSections, 1000);
            }
        });
    } else {
        setTimeout(waitForSplideSections, 1000);
    }
}

function mmSplideInit(splideElem, section) {
    var splideInstance = new Splide(splideElem, {
        type        : 'slide',
        arrows      : true,
        pagination  : false,
        gap         : '16px',
        fixedWidth  : '300px',
        perMove     : 1,
        omitEnd     : true,
        padding     : {
        },
        destroy     : false,
        breakpoints : {
            768: {
                destroy     : true,
            }
        }
    }).mount();

    // Ajout de la fonction de mise à jour de la barre de progression
    const bar = section.querySelector('.my-carousel-progress .my-carousel-progress-bar');

    function updateProgressBar() {
        const end = splideInstance.Components.Controller.getEnd() + 1; // Nombre total de slides
        const rate = Math.min((splideInstance.index + 1) / end, 1); // Calcul du ratio
        if (bar) {
            bar.style.width = `${100 * rate}%`;
        }
    }

    // Mise à jour initiale
    updateProgressBar();

    // Mise à jour lors des mouvements ou drag du carrousel
    splideInstance.on('moved', updateProgressBar);
    splideInstance.on('dragged', updateProgressBar);

    let scrollCounter = 0;

    // Ajoute l'écouteur d'événement de défilement à splideElem
    splideElem.addEventListener('wheel', function (e) {
        // Ne pas empêcher le comportement par défaut si le défilement est vertical
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        // Empêche le comportement par défaut uniquement pour le défilement horizontal
        e.preventDefault();

        // Incrémente le compteur de défilements
        scrollCounter++;

        // Vérifie si le compteur atteint le seuil pour un mouvement
        if (scrollCounter >= 12) {
            // Réinitialise le compteur
            scrollCounter = 0;

            // Déplace la diapositive selon la direction du défilement horizontal
            if (e.deltaX < 0) {
                splideInstance.go('<'); // Mouvement vers la gauche
            } else if (e.deltaX > 0) {
                splideInstance.go('>'); // Mouvement vers la droite
            }
        }
    });

    // Ajoute un écouteur pour redimensionner la fenêtre
    window.addEventListener('resize', function () {
        updateProgressBar(); // Appelle la mise à jour de la barre de progression
    });
}